import React, { useLayoutEffect } from 'react';

import { useParams, useLocation, useNavigate } from 'react-router-dom';

import Details from './Overview';
import BankStatementCollections from './BankStatementCollections';

export default function Underwriting({
  bankStatementCollections,
  refetch,
  loanFile,
}) {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  // Redirect to the first underwriting sublink if no subpath is provided
  useLayoutEffect(() => {
    if (location.pathname === `/loan-files/${id}/underwriting`) {
      navigate(`/loan-files/${id}/underwriting/overview`, { replace: true });
    }
  }, [location.pathname, id, navigate]);

  return (
    <div className="h-full bg-white">
      {location.pathname === `/loan-files/${id}/underwriting/overview` && (
        <Details />
      )}
      {location.pathname ===
        `/loan-files/${id}/underwriting/bank-statements` && (
        <BankStatementCollections
          bankStatementCollections={bankStatementCollections}
          refetch={refetch}
          loanFile={loanFile}
        />
      )}
    </div>
  );
}
